// Lightweight i18n dictionary for Grup Xaluca (FR / EN / ES).

export const LANGUAGES = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

export const TRANSLATIONS = {
  fr: {
    nav: {
      home: "Accueil",
      hotels: "Hôtels & Bivouacs",
      experiences: "Expériences",
      gastronomy: "Gastronomie",
      events: "Événements",
      brochures: "Catalogues",
      about: "À propos",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      overline: "Hôtels · Bivouacs · Sud du Maroc",
      title_1: "Le Sahara,",
      title_2: "raconté en héritage.",
      subtitle:
        "Depuis plus de trente ans, Grup Xaluca compose des séjours d'exception entre les dunes de l'Erg Chebbi et les sommets du Haut Atlas.",
      cta_primary: "Demander un séjour",
      cta_secondary: "Découvrir nos hôtels",
    },
    sections: {
      hotels_overline: "Notre collection",
      hotels_title: "Hôtels & Bivouacs",
      hotels_sub:
        "Neuf adresses, un même art de recevoir. De la kasbah fortifiée au bivouac sous les étoiles.",
      experiences_overline: "Expériences",
      experiences_title: "Aventures culturelles",
      experiences_sub:
        "Caravanes de chameaux, randonnées dans l'Atlas, sentiers de kasbahs, patrimoine berbère vivant.",
      gastronomy_overline: "Gastronomie",
      gastronomy_title: "La table du Sud",
      gastronomy_sub:
        "Tajines mijotés, méchoui, thé à la menthe et pâtisseries d'orange amère — la cuisine berbère sublimée.",
      events_overline: "Événements",
      events_title: "Le Sahara, écrin de vos moments",
      events_sub:
        "Mariages, conventions, lancements : nos équipes orchestrent vos événements dans des décors uniques.",
      heritage_overline: "Notre héritage",
      heritage_title: "Une famille, une vocation",
      heritage_text:
        "Grup Xaluca est une entreprise familiale forte de plus de 30 années d'hospitalité. Honnêteté, transparence, attachement à la culture marocaine et soutien aux communautés locales : nos valeurs essentielles.",
      testimonials_overline: "Wall of love",
      testimonials_title: "Ce que disent nos hôtes",
      cta_title: "Prêt à composer votre séjour ?",
      cta_text:
        "Notre conciergerie répond sous 24 heures pour imaginer avec vous l'itinéraire idéal.",
    },
    booking: {
      title: "Demande de séjour",
      sub: "Partagez vos envies — nous revenons vers vous sous 24 heures.",
      full_name: "Nom complet",
      email: "Adresse e-mail",
      phone: "Téléphone",
      hotel: "Hôtel ou bivouac",
      check_in: "Arrivée",
      check_out: "Départ",
      adults: "Adultes",
      children: "Enfants",
      rooms: "Chambres",
      message: "Vos envies, demandes particulières",
      submit: "Envoyer la demande",
      success: "Merci, votre demande a bien été envoyée.",
      error: "Une erreur est survenue, veuillez réessayer.",
      pick_date: "Choisir une date",
    },
    contact: {
      title: "Écrivez-nous",
      sub: "Notre équipe vous répondra dans les meilleurs délais.",
      name: "Nom",
      email: "Adresse e-mail",
      subject: "Objet",
      message: "Votre message",
      submit: "Envoyer",
      success: "Message envoyé. Nous vous répondrons rapidement.",
      error: "Erreur lors de l'envoi.",
    },
    footer: {
      tagline: "Hôtels, bivouacs et expériences dans le sud du Maroc.",
      explore: "Explorer",
      contact: "Contact",
      rights: "Tous droits réservés.",
      address: "Erfoud · Merzouga · Ouarzazate · Boumalne Dades · Maroc",
    },
    chatbot: {
      title: "Concierge IA",
      sub: "Disponible 24h/24",
      placeholder: "Demandez-moi un séjour, une excursion…",
      send: "Envoyer",
      welcome:
        "Bienvenue chez Grup Xaluca. Dites-moi ce que vous recherchez : désert, Atlas, romantique, famille, événement…",
    },
    common: {
      view: "Découvrir",
      view_hotel: "Voir l'hôtel",
      book_now: "Réserver",
      learn_more: "En savoir plus",
      back: "Retour",
      amenities: "Services & équipements",
      duration: "Durée",
      price: "À partir de",
      from: "À partir de",
      rating: "Note",
    },
    hotel: {
      welcome: "Bienvenue",
      about: "À propos de l'hôtel",
      highlights: "L'hôtel en chiffres",
      rooms: "Chambres & Suites",
      services: "Services & Équipements",
      experiences: "Expériences & Excursions",
      destination: "À découvrir aux alentours",
      spa: "Carte du Spa",
      beauty: "Beauté & Bien-être",
      food: "Restauration & Bar",
      events: "Événements & Célébrations",
      reviews: "Ils nous ont aimés",
      philosophy: "Notre philosophie",
      book_section: "Réserver votre séjour",
      contact: "Contact direct",
      ecosystem: "L'écosystème Grup Xaluca",
      ecosystem_sub: "Découvrez nos autres adresses et services dans le sud du Maroc.",
      stat_rooms: "Chambres & suites",
      stat_surface: "Surface du domaine",
      stat_airport: "Aéroport",
      stat_location: "Localisation",
      founder: "Mot du fondateur",
      restaurants: "Restaurants",
      bars: "Bars & Lounges",
      signature_drinks: "Cocktails signature",
      wines: "Notre cave",
      ingredients: "Ingrédients",
      capacity: "Capacité",
      surface_label: "Surface",
      book_room: "Réserver cette catégorie",
      reviews_cta: "Lire tous les avis",
      booking_intro: "Imaginons votre séjour ensemble. Notre équipe vous répond en moins de 24 heures.",
      group_request: "Demande groupe ou événement",
    },
  },
  en: {
    nav: {
      home: "Home",
      hotels: "Hotels & Bivouacs",
      experiences: "Experiences",
      gastronomy: "Gastronomy",
      events: "Events",
      brochures: "Brochures",
      about: "About",
      contact: "Contact",
      book: "Book",
    },
    hero: {
      overline: "Hotels · Bivouacs · Southern Morocco",
      title_1: "The Sahara,",
      title_2: "told as a legacy.",
      subtitle:
        "For more than three decades, Grup Xaluca has crafted exceptional stays between the dunes of Erg Chebbi and the peaks of the High Atlas.",
      cta_primary: "Request a stay",
      cta_secondary: "Discover our hotels",
    },
    sections: {
      hotels_overline: "Our collection",
      hotels_title: "Hotels & Bivouacs",
      hotels_sub:
        "Nine addresses, one art of hospitality — from fortified kasbahs to bivouacs beneath the stars.",
      experiences_overline: "Experiences",
      experiences_title: "Cultural adventures",
      experiences_sub:
        "Camel caravans, Atlas treks, kasbah trails, the living heritage of the Berber people.",
      gastronomy_overline: "Gastronomy",
      gastronomy_title: "The table of the south",
      gastronomy_sub:
        "Slow-cooked tagines, mechoui, mint tea and bitter-orange pastries — Berber cuisine refined.",
      events_overline: "Events",
      events_title: "The Sahara, the setting of your moments",
      events_sub:
        "Weddings, conventions, launches — our teams choreograph events in unforgettable landscapes.",
      heritage_overline: "Our heritage",
      heritage_title: "One family, one calling",
      heritage_text:
        "Grup Xaluca is a family business with over 30 years of hospitality. Honesty, transparency, devotion to Moroccan culture and support of local communities — those are our values.",
      testimonials_overline: "Wall of love",
      testimonials_title: "What our guests say",
      cta_title: "Ready to compose your stay?",
      cta_text:
        "Our concierge desk replies within 24 hours to design your ideal itinerary.",
    },
    booking: {
      title: "Booking request",
      sub: "Share your wishes — we reply within 24 hours.",
      full_name: "Full name",
      email: "Email address",
      phone: "Phone",
      hotel: "Hotel or bivouac",
      check_in: "Check-in",
      check_out: "Check-out",
      adults: "Adults",
      children: "Children",
      rooms: "Rooms",
      message: "Your wishes, special requests",
      submit: "Send request",
      success: "Thank you, your request has been received.",
      error: "Something went wrong, please try again.",
      pick_date: "Pick a date",
    },
    contact: {
      title: "Write to us",
      sub: "Our team will reply as soon as possible.",
      name: "Name",
      email: "Email address",
      subject: "Subject",
      message: "Your message",
      submit: "Send",
      success: "Message sent. We'll reply shortly.",
      error: "Sending failed.",
    },
    footer: {
      tagline: "Hotels, bivouacs and experiences in southern Morocco.",
      explore: "Explore",
      contact: "Contact",
      rights: "All rights reserved.",
      address: "Erfoud · Merzouga · Ouarzazate · Boumalne Dades · Morocco",
    },
    chatbot: {
      title: "AI Concierge",
      sub: "Available 24/7",
      placeholder: "Ask me about a stay, an excursion…",
      send: "Send",
      welcome:
        "Welcome to Grup Xaluca. Tell me what you're looking for — desert, Atlas, romantic, family, event…",
    },
    common: {
      view: "Discover",
      view_hotel: "View hotel",
      book_now: "Book now",
      learn_more: "Learn more",
      back: "Back",
      amenities: "Amenities & services",
      duration: "Duration",
      price: "From",
      from: "From",
      rating: "Rating",
    },
    hotel: {
      welcome: "Welcome",
      about: "About the hotel",
      highlights: "Quick facts",
      rooms: "Rooms & Suites",
      services: "Services & Amenities",
      experiences: "Experiences & Excursions",
      destination: "Things to do nearby",
      spa: "Spa menu",
      beauty: "Beauty & Personal Care",
      food: "Food & Beverage",
      events: "Events & Celebrations",
      reviews: "Guest reviews",
      philosophy: "Our philosophy",
      book_section: "Book your stay",
      contact: "Direct contact",
      ecosystem: "The Grup Xaluca ecosystem",
      ecosystem_sub: "Discover our other addresses and services in southern Morocco.",
      stat_rooms: "Rooms & suites",
      stat_surface: "Estate surface",
      stat_airport: "Airport",
      stat_location: "Location",
      founder: "A word from the founder",
      restaurants: "Restaurants",
      bars: "Bars & Lounges",
      signature_drinks: "Signature cocktails",
      wines: "Wine selection",
      ingredients: "Ingredients",
      capacity: "Capacity",
      surface_label: "Surface",
      book_room: "Book this room",
      reviews_cta: "Read all reviews",
      booking_intro: "Let's imagine your stay together. Our team replies in under 24 hours.",
      group_request: "Group or event request",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      hotels: "Hoteles & Bivouacs",
      experiences: "Experiencias",
      gastronomy: "Gastronomía",
      events: "Eventos",
      brochures: "Catálogos",
      about: "Nosotros",
      contact: "Contacto",
      book: "Reservar",
    },
    hero: {
      overline: "Hoteles · Bivouacs · Sur de Marruecos",
      title_1: "El Sáhara,",
      title_2: "contado como legado.",
      subtitle:
        "Durante más de treinta años, Grup Xaluca ha creado estancias excepcionales entre las dunas del Erg Chebbi y las cumbres del Alto Atlas.",
      cta_primary: "Solicitar estancia",
      cta_secondary: "Descubrir nuestros hoteles",
    },
    sections: {
      hotels_overline: "Nuestra colección",
      hotels_title: "Hoteles & Bivouacs",
      hotels_sub:
        "Nueve direcciones, un mismo arte de hospitalidad — de la kasbah fortificada al vivac bajo las estrellas.",
      experiences_overline: "Experiencias",
      experiences_title: "Aventuras culturales",
      experiences_sub:
        "Caravanas de camellos, caminatas por el Atlas, rutas kasbah, herencia bereber viva.",
      gastronomy_overline: "Gastronomía",
      gastronomy_title: "La mesa del sur",
      gastronomy_sub:
        "Tajines a fuego lento, mechoui, té con menta y dulces de naranja amarga — la cocina bereber sublimada.",
      events_overline: "Eventos",
      events_title: "El Sáhara, escenario de sus momentos",
      events_sub:
        "Bodas, convenciones, lanzamientos — nuestros equipos orquestan eventos en paisajes únicos.",
      heritage_overline: "Nuestro legado",
      heritage_title: "Una familia, una vocación",
      heritage_text:
        "Grup Xaluca es una empresa familiar con más de 30 años de hospitalidad. Honestidad, transparencia, amor por la cultura marroquí y apoyo a las comunidades locales — esos son nuestros valores.",
      testimonials_overline: "Wall of love",
      testimonials_title: "Lo que dicen nuestros huéspedes",
      cta_title: "¿Listo para componer su estancia?",
      cta_text:
        "Nuestro equipo de conserjería responde en 24 horas para diseñar su itinerario ideal.",
    },
    booking: {
      title: "Solicitud de reserva",
      sub: "Comparta sus deseos — respondemos en 24 horas.",
      full_name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      hotel: "Hotel o bivouac",
      check_in: "Llegada",
      check_out: "Salida",
      adults: "Adultos",
      children: "Niños",
      rooms: "Habitaciones",
      message: "Sus deseos, peticiones especiales",
      submit: "Enviar solicitud",
      success: "Gracias, su solicitud ha sido recibida.",
      error: "Algo salió mal, inténtelo de nuevo.",
      pick_date: "Elija una fecha",
    },
    contact: {
      title: "Escríbanos",
      sub: "Nuestro equipo responderá lo antes posible.",
      name: "Nombre",
      email: "Correo electrónico",
      subject: "Asunto",
      message: "Su mensaje",
      submit: "Enviar",
      success: "Mensaje enviado. Responderemos pronto.",
      error: "Error al enviar.",
    },
    footer: {
      tagline: "Hoteles, bivouacs y experiencias en el sur de Marruecos.",
      explore: "Explorar",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
      address: "Erfoud · Merzouga · Ouarzazate · Boumalne Dades · Marruecos",
    },
    chatbot: {
      title: "Conserje IA",
      sub: "Disponible 24/7",
      placeholder: "Pregúnteme por una estancia, una excursión…",
      send: "Enviar",
      welcome:
        "Bienvenido a Grup Xaluca. Cuéntame qué buscas: desierto, Atlas, romántico, familia, evento…",
    },
    common: {
      view: "Descubrir",
      view_hotel: "Ver hotel",
      book_now: "Reservar",
      learn_more: "Saber más",
      back: "Volver",
      amenities: "Servicios y comodidades",
      duration: "Duración",
      price: "Desde",
      from: "Desde",
      rating: "Calificación",
    },
    hotel: {
      welcome: "Bienvenido",
      about: "Sobre el hotel",
      highlights: "El hotel en cifras",
      rooms: "Habitaciones y Suites",
      services: "Servicios e Instalaciones",
      experiences: "Experiencias y Excursiones",
      destination: "Para descubrir cerca",
      spa: "Carta del Spa",
      beauty: "Belleza y Bienestar",
      food: "Restauración y Bar",
      events: "Eventos y Celebraciones",
      reviews: "Lo que dicen nuestros huéspedes",
      philosophy: "Nuestra filosofía",
      book_section: "Reserve su estancia",
      contact: "Contacto directo",
      ecosystem: "El ecosistema Grup Xaluca",
      ecosystem_sub: "Descubra nuestras otras direcciones y servicios en el sur de Marruecos.",
      stat_rooms: "Habitaciones y suites",
      stat_surface: "Superficie del dominio",
      stat_airport: "Aeropuerto",
      stat_location: "Ubicación",
      founder: "Palabras del fundador",
      restaurants: "Restaurantes",
      bars: "Bares y Lounges",
      signature_drinks: "Cócteles de autor",
      wines: "Nuestra bodega",
      ingredients: "Ingredientes",
      capacity: "Capacidad",
      surface_label: "Superficie",
      book_room: "Reservar esta categoría",
      reviews_cta: "Leer todas las opiniones",
      booking_intro: "Imaginemos su estancia juntos. Nuestro equipo responde en menos de 24 horas.",
      group_request: "Solicitud de grupo o evento",
    },
  },
};
